module.exports = __webpack_public_path__ + "img/sceneBack4.97d966af.png";